type ErrorObject = {
  [key: string]: string | string[]
}

export const useErrorMessage = (errorObj: ErrorObject) => {
  const camelCaseToNormalText = (input) => {
    const result = input.replace(/([_])/g, " ").toLowerCase()
    return result.charAt(0).toUpperCase() + result.slice(1)
  }

  const output = Object.entries(errorObj).flatMap(([field, messages]) => {
    const messageStr = Array.isArray(messages) ? messages.join(", ") : messages
    return camelCaseToNormalText(field) + " " + messageStr + "."
  })

  return output.join(" ")
}
